import clsx from 'clsx';

interface Props {
  count: number;
  name: string;
}

export default function CounterUnit({ count, name }: Props) {
  return (
    <div className="flex h-17 w-full min-w-0 flex-col items-center justify-center rounded-xs border border-solid border-border px-1 py-3 text-center font-bold">
      <div className={clsx(['text-heading-xs', count === 0 && 'text-disabled'])}>{count}</div>
      <div className="text-heading-3xs whitespace-nowrap">{name}</div>
    </div>
  );
}
